
import {combineLatest as observableCombineLatest, Subscription} from 'rxjs';
import { isNullOrUndefined } from 'util';
import {Component, OnInit, ViewChild, AfterViewChecked, OnDestroy} from '@angular/core';
import {JhiEventManager} from 'ng-jhipster';
import {Register} from '../register.service';
import {NgForm} from '@angular/forms';
import {EditableAccount, ScrollToService, CaptchaService, CreateAccountErrorType, AccountType} from '../../../shared/index';
import {ErrorService} from '../../../shared/services/error.service';
import {ParametersService} from '../../../shared/services/parameters.service';
import {Country} from '../../../shared/model/parameters.model';
import {Router} from '@angular/router';
import {CaptchaComponent} from '../../../shared/components/captcha/captcha.component';
import {AccountData} from '../../../shared/components/identite-personne/data/account.data';

@Component({
    selector: 'jhi-personne-physique',
    templateUrl: './personne-physique.component.html',
    styleUrls: ['./personne-physique.component.scss']
})
export class PersonnePhysiqueComponent implements OnInit, AfterViewChecked, OnDestroy {

    newAccount: EditableAccount;
    isTechnicalError: boolean;
    enableScroll: boolean;
    isCreateAccountBtnClicked = false;

    countries: Array<Country>;

    @ViewChild('registerForm') registerForm: NgForm;

    @ViewChild(CaptchaComponent) captcha: CaptchaComponent;

    private subscription: Subscription;

    isFCUser = false;

    constructor(
        private router: Router,
        private eventManager: JhiEventManager,
        private registerService: Register,
        private scrollToService: ScrollToService,
        private captchaService: CaptchaService,
        private errorService: ErrorService,
        private parametersService: ParametersService,
        private accountData: AccountData
    ) {
    }

    ngOnInit() {
        this.subscription = observableCombineLatest(this.registerService.newAccountAsObservable(), this.parametersService.getParameters())
            .subscribe(([newAccount, parameters]) => {
            this.countries = parameters.countries;
            this.newAccount = newAccount;
            this.newAccount.type = AccountType.PHYSIQUE;
            this.newAccount.address.pays = this.newAccount.address.pays || 'France';
            this.isFCUser = !isNullOrUndefined(this.newAccount.credentials.franceConnectSubscription);
        });
    }

    ngAfterViewChecked(): void {
        if (
            this.registerForm.submitted &&
            !this.registerForm.valid &&
            this.enableScroll
        ) {
            this.scrollToService.scrollToFirstError();
            this.enableScroll = false;
        }
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    register() {
        if (!this.registerForm.valid) {

            this.errorService.markAllControlsAsTouched(this.registerForm);
            this.captchaService.reloadCaptcha();
            this.enableScroll = true;
        } else {
            this.isTechnicalError = false;
            this.registerService.save(this.newAccount.toAccountDTO())
                .subscribe(
                    _ => this.registerSucceeded(),
                    error => this.processError(error)
                );
        }
    }

    cancel() {
        this.registerService.cancel();
    }

    private processError(error) {
        this.captchaService.reloadCaptcha();
        if (error.error.code === CreateAccountErrorType.EMAIL_ALREADY_IN_USE) {
            this.registerForm.controls['email'].setErrors({ invalid: true, emailexists: true });
            this.errorService.markAllControlsAsTouched(this.registerForm);
        } else if (error.error.code === CreateAccountErrorType.INVALID_PASSWORD) {
            this.registerForm.controls['password'].setErrors({ invalid: true, invalidPassword: true });
            this.errorService.markAllControlsAsTouched(this.registerForm);
        } else {
            this.isTechnicalError = true;
        }
        this.enableScroll = true;
    }

    private registerSucceeded() {
        this.eventManager.broadcast({
            name: 'authenticationSuccess',
            content: 'Sending Authentication Success'
        });

        if (!this.newAccount.credentials.franceConnectSubscription) {
            this.accountData.email = this.newAccount.credentials.email;
            this.router.navigate(['/inscription-reussie']);
        } else {
            this.router.navigate(['/accueil']);
        }
    }

    clickCheck() {
        this.isCreateAccountBtnClicked = true;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/register/personne-physique/personne-physique.component.ts